import update from 'immutability-helper';
import { AnyAction, Dispatch } from 'redux';

import {
  loadProximitySettings as doLoadProximitySettings,
  saveProximitySettings as doSaveProximitySettings,
} from '../services/proximitySettings';

// Actions
const START_LOAD = 'settings/proximitySettings/START_LOAD';
const COMPLETE_LOAD = 'settings/proximitySettings/COMPLETE_LOAD';
const FAIL_LOAD = 'settings/proximitySettings/FAIL_LOAD';
const START_SAVE = 'settings/proximitySettings/START_SAVE';
const COMPLETE_SAVE = 'settings/proximitySettings/COMPLETE_SAVE';
const FAIL_SAVE = 'settings/proximitySettings/FAIL_SAVE';
const RESET = 'settings/proximitySettings/RESET';

// Initial state
const initialState = {
  isLoading: false,
  isSaving: false,
  proximitySettings: undefined,
};

// Reducer
export const reducer = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case START_LOAD:
      return update(state, {
        $merge: {
          isLoading: true,
        },
      });

    case COMPLETE_LOAD:
      return update(state, {
        $merge: {
          isLoading: false,
          proximitySettings: action.proximitySettings,
        },
      });

    case FAIL_LOAD:
      return update(state, {
        $merge: {
          isLoading: false,
          proximitySettings: undefined,
        },
      });

    case START_SAVE:
      return update(state, {
        $merge: {
          isSaving: true,
        },
      });

    case COMPLETE_SAVE:
      return update(state, {
        $merge: {
          isSaving: false,
        },
      });

    case FAIL_SAVE:
      return update(state, {
        $merge: {
          isSaving: false,
        },
      });

    case RESET:
      return update(state, {
        $merge: initialState,
      });

    default:
      return state;
  }
};

// Action creators
const startLoad = () => ({
  type: START_LOAD,
});

const completeLoad = (proximitySettings: any) => ({
  type: COMPLETE_LOAD,
  proximitySettings,
});

const failLoad = () => ({
  type: FAIL_LOAD,
});

const startSave = () => ({
  type: START_SAVE,
});

const completeSave = () => ({
  type: COMPLETE_SAVE,
});

const failSave = () => ({
  type: FAIL_SAVE,
});

export const loadProximitySettings = (vendorId: number) => (dispatch: Dispatch) => {
  dispatch(startLoad());
  const loadProximitySettingsPromise = doLoadProximitySettings(vendorId);
  loadProximitySettingsPromise
    .then(proximitySettings => {
      dispatch(completeLoad(proximitySettings));
    })
    .catch(() => dispatch(failLoad()));
  return loadProximitySettingsPromise;
};

export const saveProximitySettings = (proximitySettings: any) => (dispatch: Dispatch) => {
  dispatch(startSave());
  const saveProximitySettingsPromise = doSaveProximitySettings(proximitySettings.vendorId, proximitySettings);
  saveProximitySettingsPromise.then(() => dispatch(completeSave())).catch(() => dispatch(failSave()));
  return saveProximitySettingsPromise;
};

export const resetProximitySettings = () => ({
  type: RESET,
});
